import React from 'react'
import Popover from 'antd/lib/popover'
import Icon from 'antd/lib/icon'

import s from './style.scss'

// TODO: add close icons

const HelpPopovers = {

    DrawPolygon: () =>
        <Popover
            placement="topLeft"
            arrowPointAtCenter={true}
            title={'Draw polygon'}
            content={`Mark an area on the map by using the controls on the right hand side of
                the map to draw an polygon. The returned data will contain a time series for
                every model grid point within the selected area.`}
            trigger="click"
            overlayStyle={{ 'width': '250px', }}
        >
            <Icon type="question-circle-o" className={s.helpIcon} />
        </Popover>,

    CoordinatesList: () =>
        <Popover
            placement="topLeft"
            arrowPointAtCenter={true}
            title={'Coordiantes list CSV input'}
            content={<span>
                <p>Copy/paste a list of coordinates from applications like
                Microsoft Excel®.</p>
                <p>Format: Latitude,Longitude,Altitude,Location name</p>
                <p>Altitude and location name are optional. All values may be
                    wrapped in quotes. Delimiters are auto-detected. Allowed are
                    comma, tab and semi-colon. Coordinates must be in decimal
                    degrees, <strong>not</strong> degree/minutes/seconds.
                </p>
                <p><strong>Examples of valid input</strong></p>
                <pre>
                    49.7864,7.6515,161,Basel (comma as delimiter){'\n'}
                    49.7864;7.6515;161;Basel (semicolon as delimiter){'\n'}
                    49.7864	7.6515	161	Basel (tab as delimiter){'\n'}
                    49.78,7.65,,Basel (with altitude auto-detection){'\n'}
                    49.78,7.65 (altitude auto-detection; without name)
                </pre>
                <p><strong>Coordinates and time</strong></p>
                <pre>
                    49.7864,7.6515,161,Basel,2015-05-05,2016-06-06
                </pre>

                <p><strong>Custom column order</strong></p>

                <p>If the CSV does not fit the default column order, a 
                    header can be specified:</p>
                <pre>
                    lon,lat,asl,ignore,someLocationId,enddate,startdate{'\n'}
                    7.6515,49.7864,,Some info,Location_1,2016-06-06,2015-05-05
                </pre>
                <p>Columns named "ignore" are omitted. Columns, which are
                    not identified by the parser are used as location name
                    - if there is more than one, they are concatenated. For
                    each keyword some synonyms are recognized, e.g. "lat",
                    "Lat" and "Latitude" work equally.</p>
                {/* TODO: X for closing in the upper right-hand corner */}
            </span>}
            trigger="click"
            overlayStyle={{ 'maxWidth': '600px', }}
        >
            <Icon type="question-circle-o" className={s.helpIcon} />
        </Popover>,

    TimeIntervalsList: () =>
        <Popover
            placement="topLeft"
            arrowPointAtCenter={true}
            title={'Time Intervals List'}
            content={<span>
                Examples of valid input:
                <pre>
                    <li>2011-02-15/2015-06-25 (Slash as delimiter)</li>
                    <li>2011-02-15,2015-06-25 (Comma as delimiter)</li>
                    <li>2011-02-15 2015-06-25 (Space as delimiter)</li>
                    <li>2011-02-15	2015-06-25 (Tab as delimiter)</li>
                </pre>
                <br />
                Examples of <strong>invalid</strong> input:
                <pre>
                    <li>2011-02-15, 2015-06-25 (Duplicate delimiters)</li>
                    <li>2011-02-15-2015-06-25 (Dash as delimiter)</li>
                </pre>
                {/* TODO: X for closing in the upper right-hand corner */}
            </span>}
            trigger="click"
            overlayStyle={{ 'maxWidth': '500px', }}
        >
            <Icon type="question-circle-o" className={s.helpIcon} />
        </Popover>,

    DataSeries: () =>
        <Popover
            placement="topLeft"
            arrowPointAtCenter={true}
            title={'Data Series'}
            // TODO: prod/dev switch for help link
            content={
                <span>Find detailed information about the different
                    data series on our{' '}
                    <a target="_blank" href={'https://www.meteoblue.com/en/weather/docs/historydata'}>
                        data series help page</a>
                </span>
            }
            trigger="click"
            overlayStyle={{ 'maxWidth': '250px', }}
        >
            <Icon type="question-circle-o" className={s.helpIcon} />
        </Popover>,

    GapFill: () =>
        <Popover
            placement="topLeft"
            arrowPointAtCenter={true}
            title={'Fill gaps with '}
            // TODO help text for gap fill. what is this and when to choose what
            content={'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy' +
                'tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos ' +
                ' accusam et justo duo dolores et ea rebum.'}
            trigger="click"
            overlayStyle={{ 'width': '250px', }}
        >
            <Icon type="question-circle-o" className={s.helpIcon} />
        </Popover>,

    YearsExample: () =>
        <Popover
            title={'Input example'}
            content={
                <span>
                    <strong>Single years:</strong> 2005, 2010, 2015 <br />
                    <strong>Year range:</strong> 2010-2015 <br />
                    <strong>Both:</strong> 2000-2008, 2015 <br />
                    Spaces are optional.<br />
                    In ranges, start and end are inclusive.<br />
                    A year must have 4 digits.
                </span>
            }
            trigger="click"
        >
            <span className={s.linklikeNoColor}>Input example</span>
        </Popover>,

    CombineLocationsAndTime: () =>
        <Popover
            title={'Combine locations and time intervals'}
            content={
                <span>
                    If this option is enabled, the first time interval will be
                    used for the first location, the second time interval for
                    the second location and so on. This option is not available
                    for polygons.

                    <p><strong>Example:</strong></p>

                    <p>Suppose 2 locations (Basel and Luzern) and 2 time intervals
                    (2016 and 2017) are selected.</p>

                    <p>
                        This option <strong>not</strong> enabled results in 4
                        data series:<br />
                        Basel 2016<br />
                        Basel 2017<br />
                        Luzern 2016<br />
                        Luzern 2017<br />
                    </p>

                    <p>
                        This option enabled results in 2 data series:<br />
                        Basel 2016<br />
                        Luzern 2017<br />
                    </p>
                </span>
            }
            trigger="click"
            overlayStyle={{ 'maxWidth': '500px' }}
        >
            <span className={s.linklikeNoColor}>See example</span>
        </Popover>,

    AlignIntervalsInChart: () =>
        <Popover
            title={'Align intervals in chart'}
            content={
                <span>
                    <p>This option determines where graphs begin in the chart.</p>
                    <p><strong>None</strong><br />
                    Graphs appear in normal order.</p>
                    <p><strong>Same start day</strong><br />
                    All graphs begin at the same day, i.e. the day at which the 
                    first graph begins. This is useful for comparing multiple 
                    time intervals with each other.</p>
                    <p><strong>Same start year</strong><br />
                    All graphs begin at the beginning of the same year, i.e. the
                    year in which the first graph begins. This is useful for
                    year comparisons.</p>
                </span>
            }
            trigger="click"
            overlayStyle={{'maxWidth': '350px'}}
        >
            <Icon type="question-circle-o" className={s.helpIcon} />
        </Popover>

}

export default HelpPopovers